import "./authentication/webawesome";
import "./utils/mrujs-and-cablecar";
import { ensureDeclarativeOpenModalDialogsAreModal } from "./vendor/@practical-computer/practical-views/util/ensure-delcarative-open-modal-dialogs-are-modal";

document.addEventListener(
  `DOMContentLoaded`,
  ensureDeclarativeOpenModalDialogsAreModal,
);


import "./elements/application-error-handling";
import "./elements/cookie-consent";
import "./elements/password-strength-feedback";
import "./elements/push-notification-status";
import "./elements/toggle-password-visibility";

